const addTemplates = (editor) => {

    // This is the function to add css styles to the components
    // Every new component added to the editor will have a class type
    // Based on the class type, the css styles will be added to the component
    editor.on('component:create', (component) => {
        const currentStyles = JSON.parse(localStorage.getItem('gjs-styles'));

        if (component.attributes.attributes.classtype !== undefined) {
            const compsClasses = [component.attributes.attributes.classtype];
            const cssName = `.${component.attributes.attributes.classtype}`;
            let cssStyles;
            if (component.attributes.attributes.classtype === 'bg-green') {
                cssStyles = { 'background-color': 'rgb(41, 79, 93) !important' };
            } else if (component.attributes.attributes.classtype === 'text-green') {
                cssStyles = { 'color': '#294f5d !important' };
            } else if (component.attributes.attributes.classtype === 'text-gray') {
                cssStyles = { 'color': '#C5C7CD !important' };
            } else if (component.attributes.attributes.classtype === 'sidebar-container' || component.attributes.attributes.classtype === 'leftbar-container') {
                cssStyles = { 
                    'background-color': '#294F5D !important',
                    'border-radius': '18px !important',
                    'box-shadow': '12px 8px 13px rgba(0, 0, 0, 0.25) !important'};
            } else if (component.attributes.attributes.classtype === 'searchbar') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'border-radius': '0 10px 10px 0 !important' };
            } else if (component.attributes.attributes.classtype === 'searchbar-button') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'border-radius': '10px 0 0 10px !important' };
            } else if (component.attributes.attributes.classtype === 'list-button') {
                cssStyles = { 
                    'background-color': '#20df7f !important',
                    'box-shadow': '0px 4px 4px rgba(0, 0, 0, 0.3) !important',
                    'border-radius': '10px !important',
                    'font-style': 'normal !important',
                    'font-weight': '700 !important',
                    'font-size': '20px !important',
                    'line-height': '20px !important',
                    'color': '#224957 !important' };
            } else if (component.attributes.attributes.classtype === 'patientcard-text') {
                cssStyles = { 
                    'margin-left': '-80px !important',
                    'border-radius': '57px !important',
                    'background-color': 'rgba(217, 217, 217, 0.5) !important',
                    'box-shadow': '0px 4px 4px rgba(0, 0, 0, 0.25) !important'};
            } else if (component.attributes.attributes.classtype === 'user-img') {
                cssStyles = { 
                    'z-index': '1 !important'};
            } else if (component.attributes.attributes.classtype === 'data-card') {
                cssStyles = { 
                    'color': '#294f5d !important',
                    'background-color': 'rgba(217, 217, 217, 0.6) !important',
                    'box-shadow': '2px 7px 9px rgba(0, 0, 0, 0.25) !important',
                    'border-radius': '18px !important' };
            } else if (component.attributes.attributes.classtype === 'data-card2') {
                cssStyles = { 
                    'background-color': '#294f5d !important',
                    'box-shadow': '2px 7px 9px rgba(0, 0, 0, 0.25) !important',
                    'border-radius': '18px !important' };
            } else if (component.attributes.attributes.classtype === 'edit-button') {
                cssStyles = { 
                    'background-color': '#F2F2F2 !important',
                    'box-shadow': '2px 2px 12px rgba(0, 0, 0, 0.3) !important',
                    'border-radius': '10px !important' };
            } else if (component.attributes.attributes.classtype === 'container-bg') {
                cssStyles = { 
                    'background-color': 'rgba(12, 12, 12, 0.04) !important' };
            } else if (component.attributes.attributes.classtype === 'login-container') {
                cssStyles = { 
                    'box-shadow': '14px 24px 49px rgba(0, 0, 0, 0.15) !important',
                    'border-radius': '43px !important' };
            } else if (component.attributes.attributes.classtype === 'login-container--text') {
                cssStyles = { 
                    'font-style': 'normal !important',
                    'font-weight': '400 !important',
                    'font-size': '18px !important',
                    'line-height': '22px !important',
                    'color': '#224957 !important' };
            } else if (component.attributes.attributes.classtype === 'login-container--input') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'border-radius': '10px 0 0 10px !important' };
            } else if (component.attributes.attributes.classtype === 'login-container--input_label') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'border-radius': '0 10px 10px 0 !important' };
            } else if (component.attributes.attributes.classtype === 'login-container--input_checkbox') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'border-radius': '5px !important' };
            } else if (component.attributes.attributes.classtype === 'login-container--button') {
                cssStyles = { 
                    'background-color': '#20DF7F !important',
                    'box-shadow': '0px 4px 4px rgba(0, 0, 0, 0.3) !important',
                    'border-radius': '10px !important',
                    'font-style': 'normal !important',
                    'font-weight': '400 !important',
                    'font-size': '16px !important',
                    'line-height': '20px !important',
                    'color': '#224957 !important' };
            } 
        
            // Add the new style to the local storage and to the css
            const newCreatedSelectors = [{ selectors: [compsClasses], style: cssStyles }];
            localStorage.setItem(
                'gjs-styles',
                JSON.stringify([...currentStyles, ...newCreatedSelectors])
            );
            const css = editor.Css;
            css.setRule(cssName, cssStyles);
        }

        if (component.attributes.attributes.statetype !== undefined) {
            const compsClasses = [component.attributes.attributes.statetype];
            let cssName = `.${component.attributes.attributes.statetype}`;
            let state;
            let cssStyles;
            if (component.attributes.attributes.statetype === 'searchbar') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'box-shadow': 'none !important'
                };
                state = 'focus';
                cssName = `${cssName}:focus`;
            } else if (component.attributes.attributes.statetype === 'offcanvas-body--item') {
                cssStyles = { 
                    'background-color': 'rgba(217, 217, 217, 0.5) !important',
                    'box-shadow': '-3px 10px 29px rgba(0, 0, 0, 0.25) !important'
                };
                state = 'hover';
                cssName = `${cssName}:hover`;
            } else if (component.attributes.attributes.statetype === 'login-container--input_checkbox') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                };
                state = 'checked';
                cssName = `${cssName}:checked`;
            } else if (component.attributes.attributes.statetype === 'login-container--input') {
                cssStyles = { 
                    'background-color': '#224957 !important',
                    'box-shadow': 'none !important'
                };
                state = 'focus';
                cssName = `${cssName}:focus`;
            }
        
            // Add the new style to the local storage and to the css
            const newCreatedSelectors = [{ selectors: [compsClasses], style: cssStyles, state: state }];
            localStorage.setItem(
                'gjs-styles',
                JSON.stringify([...currentStyles, ...newCreatedSelectors])
            );
            const css = editor.Css;
            css.setRule(cssName, cssStyles);
        }

        if (component.attributes.attributes.pseudotype !== undefined) {
            const compsClasses = [component.attributes.attributes.pseudotype];
            let cssName = `.${component.attributes.attributes.pseudotype}`;
            let pseudo;
            let cssStyles;
            if (component.attributes.attributes.pseudotype === 'searchbar') {
                cssStyles = { 
                    'color': 'white !important',
                    'opacity': '1 !important', 
                    'font-style': 'normal !important',
                    'font-weight': '400 !important',
                    'font-size': '14px !important',
                    'line-height': '20px !important'
                };
                pseudo = 'placeholder';
                cssName = `${cssName}::placeholder`;
            } else if (component.attributes.attributes.statetype === 'login-container--input') {
                cssStyles = { 
                    'color': 'white !important',
                    'opacity': '1 !important', 
                    'font-style': 'normal !important',
                    'font-weight': '400 !important',
                    'font-size': '14px !important',
                    'line-height': '20px !important'
                };
                pseudo = 'placeholder';
                cssName = `${cssName}::placeholder`;
            } 
        
            // Add the new style to the local storage and to the css
            const newCreatedSelectors = [{ selectors: [compsClasses], style: cssStyles, pseudo: pseudo }];
            localStorage.setItem(
                'gjs-styles',
                JSON.stringify([...currentStyles, ...newCreatedSelectors])
            );
            const css = editor.Css;
            css.setRule(cssName, cssStyles);
        }
  });
};

export default addTemplates;
